<div *ngIf="!isRequestFailed">
    <h2 class="sectionTitle">Long Haul Requests Management</h2>
    <div class="bs-callout bs-callout-info"> 
        <h4>Please Note</h4> 
        <p>Search Term Scope (Rebate File Number - Vessel Name - IMO Number)</p>
    </div>
    <div class="services-filter">
        <div class="form-container">
            <h4 class="section-title">Search</h4>
            <div class="form-section">
            </div>
            <div class="form-section">
                <div class="form-group">
                    <label for="txtRequestNumber">Search Term</label>
                    <input type="text" class="form-control" id="txtRequestNumber" name="txtRequestNumber" [(ngModel)]="searchTerm" />
                </div>
            </div>
        </div>
        <div class="btns-holder text-center">
            <input type="button" class="btn btn-primary SCAcustomBtn" (click)="loadLongHaulRequests()" value="Search" />
            <input type="button" class="btn btn-primary SCAcustomBtn" (click)="resetLongHaulRequests()" value="Reset" />
        </div>
    </div>
    <app-grid-view #LongHaulRequests></app-grid-view>
</div>
<!-- Error -->
<div *ngIf="isRequestFailed" class="alert alert-danger" role="alert">
    <div class="alignC">
        <i class="icon-error"></i>
        <p>Something went wrong, Please contact System Administrator</p>
        <hr>
        <p>Go Back to <a routerLink="/workspace">Workspace</a></p>
    </div>
</div>